import React, { useMemo, useState } from "react";

import left from "./assets/chevron-left.svg";
import right from "./assets/chevron-right.svg";

interface MediaItem {
    url?: string;
    [key: string]: unknown;
}

interface PitchImagesCarouselProps {
    media?: MediaItem[];
    showIndicator?: boolean;
}

const PitchImagesCarousel: React.FC<PitchImagesCarouselProps> = ({ media = [], showIndicator = true }) => {
    const mediaList = useMemo(
        () => (Array.isArray(media) ? media : []),
        [media]
    );
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const hasImages = mediaList.length > 0;

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex < mediaList.length - 1 ? prevIndex + 1 : 0
        );
    };

    const handlePreviousImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : mediaList.length - 1
        );
    };

    const backgroundStyles: React.CSSProperties = hasImages
        ? {
            backgroundImage: `url(${mediaList[currentImageIndex]?.url || ""})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        }
        : {};

    return (
        <div className="relative w-full h-[400px] bg-[#B1BFC2] rounded-xl">
            <div
                style={backgroundStyles}
                className="w-full h-full rounded-xl transition-all duration-300"
            ></div>

            {/* Conditionally render buttons if there is more than one image */}
            {mediaList.length > 1 && (
                <>
                    {/* Previous Button */}
                    <button
                        onClick={handlePreviousImage}
                        className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md"
                    >
                        <img src={left} alt="Previous" />
                    </button>

                    {/* Next Button */}
                    <button
                        onClick={handleNextImage}
                        className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md"
                    >
                        <img src={right} alt="Next" />
                    </button>
                </>
            )}

            {/* Image Indicator Dots */}
            {showIndicator && mediaList.length > 0 && (
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                    {mediaList.map((_, index) => (
                        <div
                            key={index}
                            className={`w-3 h-3 rounded-full ${index === currentImageIndex ? "bg-[#317333]" : "bg-[#D3D3D3]"
                                }`}
                        ></div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PitchImagesCarousel;
